<script setup>
import {
    toRefs, defineProps, ref,
    defineEmits,
    defineExpose,
    watch
} from 'vue';
import { useRoute } from "vue-router";
import Swal from "sweetalert2";
import { showMessage } from "@/utils/hooks/message"
import i18n from "@/i18n"
import { uploadFile } from "@/service";
import { getLangValue } from "@/utils/common"; //获取后端语言
// import flatPickr from "vue-flatpickr-component";
const route = useRoute()
const props = defineProps({
    indicatorList: {
        type: Array,
        default: () => {
            return []
        }
    },
    isCheckForm: {
        type: Boolean,
        default: false
    },
    company_list: {
        type: Array,
        default: () => []
    },
})
const allcheck = ref(false)
// 增加一个永久选项
const shortcuts = [
    {
        text: getLangValue("base.permanent"),
        value: `9999-12-31`,
    },
];
const emits = defineEmits(["onAddgroupindicator", "onDeleteGroupindicator", "onDeleteGroup", "showInfo", "onUpload", 'onDeleteFile', 'allcheckFun'])

const { indicatorList, company_list } = toRefs(props)
// const company_list = ref([]) // 存储所有的检测机构
const company_name_list = ref([
    []
]) // 存储筛出来的检测机构
const loadingList = ref([false])


// const deleteGroupindicator = (g_i) => {
//     Swal.fire({
//         title: i18n.global.t("base.delete_alert_title"),
//         text: i18n.global.t("base.delete_alert_info"),
//         icon: "warning",
//         showCancelButton: true,
//         cancelButtonColor: "#f46a6a",
//         confirmButtonColor: "#34c38f",
//         confirmButtonText: i18n.global.t("base.done"),
//         cancelButtonText: i18n.global.t("base.cancel"),
//     }).then(async (result) => {
//         if (result.isConfirmed) {
//             emits("onDeleteGroupindicator", g_i)
//         }
//     });

// }

// const addGroupindicator = () => {
//     emits("onAddgroupindicator")
// }

// const chnagegroupindicatorName =(i,g_i)=> {
//     console.log(i, g_i);
//     const {indicatorList} = groupInfoList.value[i];
//     const {name} = indicatorList[g_i];
//     console.log(name);
//     // 筛选名称看是否重复
//     let arr =indicatorList.filter(item=> item.name === name)
//     console.log(arr);
//     if(arr.length> 1){
//         emits("showInfo")
//     }
// }
// const getCompanyList = async () => {
//     /**获取检测机构企业列表 */
//     const resp = await getCompanyNameList();
//     if (resp.code === 0) {
//         company_list.value = resp.payload;
//     } else {
//         showMessage('danger', resp.msg);
//     }
// }
const remoteMethod = async (query, key) => {
    /**远程搜索 */
    // console.log(query);
    if (query) {
        loadingList.value[key] = true
        let arr = company_list.value.filter(item => item.company_name.includes(query) || item.company_name.includes(query.toLowerCase()) || item.company_name.includes(query.toUpperCase()))
        if (arr.length > 0) {
            company_name_list.value[key] = [arr[0].company_name]
        } else {
            company_name_list.value[key] = [query]
        }
        loadingList.value[key] = false
    } else {
        company_name_list.value[key] = []
    }
}

const changeCompany = (i) => {
    /**
     * ?切换企业,选择已有的检测机构把啊认证资质机构  认证有效期带出来
     * @param i 索引
     */
    let index = company_list.value.findIndex(item => item.company_name == indicatorList.value[i].testing_institution)
    if (index > -1) {
        //设置信息
        indicatorList.value[i].certification_body = company_list.value[index].company_qualification_certification_body
        indicatorList.value[i].validity_period_of_certification = company_list.value[index].company_qualification_validity_period
    }
}

const deleteFile = (i, i_i) => {
    Swal.fire({
        title: getLangValue("base.delete_alert_title"),
        text: getLangValue("base.delete_alert_info"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: getLangValue("base.done"),
        cancelButtonText: getLangValue("base.cancel"),
        customClass: {
            container: 'my-popup-class'
        },
    }).then(async (result) => {
        if (result.isConfirmed) {
            emits("onDeleteFile", { i: i, file_i: i_i })
        }
    });
}

const handleChange = (file, _fileList, index) => {
    // console.log(file, fileList, index);
    // 验证 类型 .png,.jpg,.jpeg,.pdf,.docx,.doc,.xlsx,.xls
    const fileFormat = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase();
    const allowExtensions = ['png', 'jpg', 'jpeg', 'pdf', 'docx', 'doc', 'xlsx', 'xls'];
    if (!allowExtensions.includes(fileFormat)) {
        showMessage('danger', getLangValue('upload.notCorrectType'))
        return;
    }
    //验证大小
    let fileMaxSize = 1024 * 1024 * 50
    if (file.size > fileMaxSize) {
        showMessage('danger', getLangValue('upload.fileSizeLimit'))
        return;
    }
    // 上传文件
    uploadFile(file.raw)
        .then((res) => {
            emits("onUpload", { index: index, file: res.data.payload })
        })
        .catch((e) => {
            console.log(e);
        });
}
const mouseOver = (item) => {
    //!鼠标移除
    item.showReference = true;
}
const mouseLeave = (event, item) => {
    // 获取鼠标离开时的元素
    let relatedTarget = event.relatedTarget;
    if (relatedTarget && relatedTarget.className == "popover-arrow") {
        return;
    }
    item.showReference = false;
}
watch(allcheck, () => {
    emits('allcheckFun', allcheck.value)
})
defineExpose({
    allcheck
})

</script>
<template>
    <div class="group-content">
        <div class="group row">
            <div class="group-index" v-if="indicatorList.length" style="overflow-x: auto;">
                <div class="group-index-title">
                    <div class="d-flex align-items-center" style="max-width: 140px;">
                        <input style="min-width:14px; display: inline;" class="form-check-input mt-0 mx-2"
                            type="checkbox" v-model="allcheck" aria-label="Checkbox for following text input">
                        <!-- <span class="text-danger">*</span> -->
                        {{
                            getLangValue('hscode.indicatorName') }}
                    </div>
                    <div style="max-width: 100px;">{{ getLangValue('attribute.value') }}</div>
                    <div style="max-width: 100px;">{{ getLangValue('attribute.unit') }}</div>
                    <!-- <div>{{ $t('attribute.reference') }}</div> -->
                    <div>
                        <!-- <span class="text-danger">*</span> -->
                        {{
                            getLangValue('product-template.testingOrganization') }}
                    </div>
                    <div>
                        <!-- <span class="text-danger">*</span> -->
                        {{
                            getLangValue('product-template.testingOrganizationQualification') }}
                    </div>
                    <!-- <div style="max-width: 80px;">*{{ getLangValue('product_template.report') }}</div> -->
                    <div>{{ getLangValue('product-template.testDate') }}</div>
                    <div>{{ getLangValue('product-template.testinginstitutions') }}</div>
                    <div>{{ getLangValue('product-template.testinginstitutions1') }}</div>
                    <!-- <div style="max-width: 120px;">{{ getLangValue('product_template.remark') }}</div> 2024-09-20去掉备注信息 -->
                    <div style="max-width: 120px;">{{ getLangValue('product_template.annex') }}</div>
                    <!-- <div style="flex:unset;width: 48px;"></div> -->
                </div>
                <div class="group-index-input" v-for="(groupindicator, groupindicatorindicator_index) in indicatorList"
                    :key="`groupindicator--${groupindicatorindicator_index}`">
                    <div style="word-break: break-all; max-width: 140px;" class="d-flex align-items-center">
                        <input style="min-width:14px; display: inline;" class="form-check-input mt-0 mx-2"
                            type="checkbox" v-model="groupindicator.checked"
                            aria-label="Checkbox for following text input">
                        <input v-model="groupindicator.name" type="text" class="form-control" :class="[
                            (isCheckForm && !groupindicator.name) && 'is-invalid',
                        ]" required v-if="groupindicator.isNewAdd" />
                        <span v-else>{{ i18n.global.locale == 'en' ? groupindicator.name_en : groupindicator.name }}</span>
                        <i :id="groupindicator.id" class="ri-question-line" @mouseover="mouseOver(groupindicator)"
                            @mouseleave="mouseLeave($event, groupindicator)"></i>
                        <b-popover :target="groupindicator.id" v-model:show="groupindicator.showReference" triggers="">
                            <div :ref="`reference${groupindicator.name}`" style="min-width: 200px;"
                                @mouseleave="groupindicator.showReference = false">
                                <b-form-textarea v-show="i18n.global.locale == 'ch'" v-model="groupindicator.reference"
                                    disabled :placeholder="getLangValue('attribute.reference')"
                                    rows="3"></b-form-textarea>
                                <b-form-textarea v-show="i18n.global.locale == 'en'" v-model="groupindicator.reference_en"
                                    disabled :placeholder="getLangValue('attribute.reference_en')"
                                    rows="3"></b-form-textarea>
                            </div>
                        </b-popover>
                    </div>
                    <div style="max-width: 100px;word-break: break-all;"><input v-model="groupindicator.value"
                            type="text" class="form-control" required />
                    </div>
                    <div style="max-width: 100px;word-break: break-all;">
                        <input v-model="groupindicator.unit" type="text" class="form-control" required
                            v-if="groupindicator.isNewAdd" />
                        <span v-else>{{ i18n.global.locale == 'en' ? groupindicator.unit_en : groupindicator.unit }}</span>
                    </div>
                    <!-- <div style="word-break: break-all;">
                        <textarea style="height: 37.5px;" v-model="groupindicator.reference" class="form-control"
                            required v-if="groupindicator.isNewAdd" />
                        <span v-else>{{ groupindicator.reference }}</span>
                    </div> -->
                    <div style="height: 37.5px;">
                        <!-- :class="[(isCheckForm && !groupindicator.testing_institution) && 'is-invalid']" -->
                        <!-- <input :placeholder="getLangValue('product-management','message1')" v-model="groupindicator.testing_institution"
                            type="text" class="form-control" required /> -->
                        <el-select style="width: 90%;height: 100%; margin: 0;"
                            v-model="groupindicator.testing_institution"
                            @change="changeCompany(groupindicatorindicator_index)" filterable
                            :loading="loadingList[groupindicatorindicator_index]"
                            :remote-method="(query) => remoteMethod(query, groupindicatorindicator_index)" remote
                            allow-create :placeholder="getLangValue('product-management', 'message1')" size="large"
                            clearable>
                            <el-option v-for="item1 in company_name_list[groupindicatorindicator_index]"
                                :key="item1.key" :label="item1" :value="item1">
                            </el-option>
                        </el-select>
                    </div>
                    <div><input :placeholder="getLangValue('product-management', 'message2')"
                            v-model="groupindicator.qualification_of_testing_institution" type="text"
                            class="form-control" required /></div>
                    <!-- :class="[(isCheckForm && !groupindicator.qualification_of_testing_institution) && 'is-invalid']" -->
                    <!-- <div style="max-width: 80px;"><el-select
                            :class="[(isCheckForm && !groupindicator.has_report) && 'is-invalid']"
                            v-model="groupindicator.has_report" size="large" placeholder="   " style="width: 80px; "
                            clearable>
                            <el-option label="是" value="是" />
                            <el-option label="否" value="否" />
                        </el-select></div> -->
                    <!-- 2024-09-02新增信息 -->
                    <div>
                        <!-- <flat-pickr v-model="groupindicator.certification_date" style="background-color: unset;"
                            :config="{ enableTime: false, dateFormat: 'Y-m-d' }" class="form-control">
                        </flat-pickr> -->
                        <el-date-picker style="height: 37.5px; width: 100%;" v-model="groupindicator.certification_date"
                            size="large" value-format="YYYY-MM-DD" />
                    </div>
                    <div>
                        <!-- <flat-pickr v-model="groupindicator.validity_period_of_certification"
                            style="background-color: unset;" :config="{ enableTime: false, dateFormat: 'Y-m-d' }"
                            class="form-control">
                        </flat-pickr> -->
                        <el-date-picker :shortcuts="shortcuts" style="height: 37.5px; width: 100%;"
                            v-model="groupindicator.validity_period_of_certification" size="large"
                            value-format="YYYY-MM-DD" />
                    </div>
                    <div><input v-model="groupindicator.certification_body" type="text" class="form-control" required />
                    </div>
                    <!-- 2024-09-02新增信息 -->
                    <!-- <div style="max-width: 120px;"><input v-model="groupindicator.remark" type="text"
                            class="form-control" required /></div>2024-09-20去掉备注信息 -->
                    <div style="max-width: 120px;">
                        <div v-if="groupindicator.extra?.fileList && groupindicator.extra?.fileList.length">
                            <div v-for="(file, i) in groupindicator.extra.fileList" :key="i"
                                class="d-flex align-items-center" style="color: #6691E7; text-decoration: underline;">
                                {{ file.filename }}
                            </div>
                            <i class="fs-16 ri-delete-bin-5-fill cursor-pointer" v-if="route.query.type != 'view'"
                                style="color: #F06548; margin-left: 10px;"
                                @click="deleteFile(groupindicatorindicator_index, i)"></i>
                        </div>
                        <div style="width: 20px;" v-else>
                            <el-upload class="upload-demo" :auto-upload="false" multiple
                                :accept="'image/png, image/jpeg,image/jpg,application/pdf,application/msword,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.wordprocessingml.document'"
                                :on-change="(file, fileList) => handleChange(file, fileList, groupindicatorindicator_index)"
                                :show-file-list="false">
                                <i class=" ri-add-circle-fill" style="color: #8591A2; font-size: 16px;"></i>
                            </el-upload>
                        </div>

                        <!-- <el-popover v-if="groupindicator.fileList && groupindicator.fileList.length"
                            placement="left-start" :title="$t('upload.uploadedFile')" :width="600" trigger="click">
                            <template #reference>
                                <i class="ri-file-upload-line cursor-pointer"></i>
                            </template>
<div style="width: 600px;" v-for="(file, i) in groupindicator.fileList" :key="i" class="d-flex align-items-center">
    {{ file.filename }}
    <i class="fs-16 ri-delete-bin-5-fill cursor-pointer" v-if="route.query.type != 'view'"
        style="color: #F06548; margin-left: 10px;" @click="deleteFile(groupindicatorindicator_index, i)"></i>
</div>
</el-popover> -->

                        <!-- <div class="flex-1" v-if="groupindicator.fileList && groupindicator.fileList.length">
                            <div style="width: 200px;" v-for="(file, i) in groupindicator.fileList" :key="i">{{ file.filename }}</div>
                        </div> -->
                        <!-- <button type="button" class="btn" v-if="groupindicator.isNewAdd"
                            style="background-color: #405189;color: white; min-width: 50px; height: 30px; padding: 5px; "
                            @click="deleteGroupindicator(groupindicatorindicator_index)">{{
                                $t("base.delete")
                            }}</button> -->
                    </div>

                </div>

            </div>
            <div style="text-align: center; margin-top: 10px;">
                <!-- <button type="button" class="btn btn-primary me-3" style="background-color: #2C404C;"
                    @click="addGroupindicator">{{ $t("hscode.addIndicator1")
                    }}</button> -->
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
.group-content {
    .group {
        margin: 10px 0;

        .group-index {

            .group-index-title,
            .group-index-input {
                display: flex;
                align-items: center;

                div {
                    flex: 1;
                    margin: 2px;
                }

                :deep(.el-select__wrapper) {
                    height: 100% !important;
                    min-height: unset !important;
                    box-shadow: 0 0 0 1px #ced4da inset;
                }

                :deep(.el-select__placeholder.is-transparent) {
                    color: #888a98;
                }
            }
        }
    }

}
</style>
<style>
.my-popup-class {
    z-index: 99999999 !important;
}
</style>